import DefaultDrawer from '../defaultDrawer/DefaultDrawer';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import EditProfileForm from '../../../forms/editProfile/EditProfileForm';
import './EditProfileDrawer.scss';
import { ReactComponent as GRLogo } from '../../../../../resources/images/svg/GRLogo.svg';
import useTranslation from '../../../../hooks/translation/useTranslation';

function EditProfileDrawer({
  formOptions,
  showEditProfile,
  setShowEditProfile,
  errors,
  handleSubmit,
  form,
}) {
  const { configInfo } = useTranslation();
  const { width } = useWindowDimensions();

  const isGeorgia = configInfo?.countryCode === 'GE';

  return (
    <DefaultDrawer
      show={width < 1024 && showEditProfile}
      setShow={setShowEditProfile}
      className="edit-profile-drawer"
      title={(
        <div className="flex items-center justify-between pr-10 xsm:pr-5">
          {isGeorgia ? <GRLogo />
            : (
              <img
                src="/ticketLogos/mobileLogoArm.png"
                alt="Armenia Railway Logo"
                width={90}
                height={42}
              />
            )}
        </div>
  )}
    >
      <EditProfileForm
        errors={errors}
        options={formOptions}
        handleSubmit={handleSubmit}
        form={form}
      />
    </DefaultDrawer>
  );
}

export default EditProfileDrawer;
